// extracted by mini-css-extract-plugin
export default {"container":"Header_container__F-TvP","button":"Header_button__IPM59","titleContainer":"Header_titleContainer__vB8bc","title":"Header_title__jtIbL"};